import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: "/"
  },
  {
    path: '/',
    name: 'home',
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "RAJ5 Lending Corporation"
    }
  },
  {
    path: '/repayment',
    component: () => import("@/views/repayment/index.vue"),
    children: [
      {
        path: "",
        name: "dragonpay",
        component: () => import("@/views/repayment/dragonpay.vue"),
        meta: {
          title: "RAJ5 | Repayment of Loan"
        }
      },
      {
        path: "bank-account",
        name: "bankaccount",
        component: () => import("@/views/repayment/bankaccount.vue")
      }
    ]
  },
  {
    path: '/news',
    name: 'News',
    component: () => import("@/views/news/news.vue"),
    meta: {
      title: "RAJ5 | News and Promos"
    }
  },
  {
    path: '/promos',
    name: 'Promos',
    component: () => import("@/views/news/promos.vue"),
    meta: {
      title: "RAJ5 | News and Promos"
    }
  },
  {
    path: '/articles',
    name: 'Articles',
    component: () => import("@/views/news/articles.vue"),
    meta: {
      title: "RAJ5 | Articles"
    }
  },
  {
    path: '/faqs',
    component: () => import("@/views/faqs/index.vue"),
    children: [
      {
        path: "",
        name: 'Obtaining Loan',
        component: () => import("@/views/faqs/loan.vue"),
        meta: {
          title: "RAJ5 | Frequently Ask Questions"
        }
      },
      {
        path: 'loan-repayment',
        name: 'Loan Repayment',
        component: () => import("@/views/faqs/repayment.vue"),
      },
      {
        path: 'about-company',
        name: 'About',
        component: () => import("@/views/faqs/about.vue"),
      },
      {
        path: 'responsibles',
        name: 'Lend Responsibly',
        component: () => import("@/views/faqs/responsible.vue"),
      }
    ]
  },
  {
    path: '/contacts',
    component: () => import("@/views/contacts/index.vue"),
    children: [
      {
        path: '',
        name: 'Contacts',
        component: () => import("@/views/contacts/contact.vue"),
        meta: {
          title: "RAJ5 | Contact Us"
        }
      },
      {
        path: 'cookie',
        name: 'Cookie Policy',
        component: () => import("@/views/contacts/cookie.vue"),
      },
      {
        path: 'privacy',
        name: 'Privacy Policy',
        component: () => import("@/views/contacts/privacy.vue"),
      },
      {
        path: 'terms',
        name: 'Terms and Conditions',
        component: () => import("@/views/contacts/terms.vue"),
      },
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index.vue"),
    meta: {
      title: "RAJ5 | Login"
    }
  },
  {
    path: "/registration",
    component: () => import("@/views/registration/index.vue"),
    children: [
      {
        path: '',
        name: "Step 1",
        component: () => import("@/views/registration/step1.vue"),
        meta: {
          title: "RAJ5 | Register"
        }
      },
      {
        path: 'step-2',
        name: "Step 2",
        component: () => import("@/views/registration/step2.vue"),
      },
      {
        path: 'step-3',
        name: "Step 3",
        component: () => import("@/views/registration/step3.vue"),
      },
      {
        path: 'step-4',
        name: "Step 4",
        component: () => import("@/views/registration/step4.vue"),
      },
      {
        path: 'step-5',
        name: "Step 5",
        component: () => import("@/views/registration/step5.vue"),
      },
      {
        path: 'step-6',
        component: () => import("@/views/registration/step6.vue"),
        children: [
          {
            path: '',
            name: "Step 6",
            component: () => import("@/views/registration/step6-photo.vue"),
          },
          {
            path: 'id',
            name: "ID Upload",
            component: () => import("@/views/registration/step6-id.vue"),
          },
        ]
      },
      {
        path: 'step-7',
        name: "Step 7",
        component: () => import("@/views/registration/step7.vue"),
      },
    ],
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
  // window.scrollTo(0, 0);

  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }

  next();
});

export default router
